import { TransactionService } from "../../_services/api/templates/transactions.services";
import { BankAccountTransactionServices } from "../../_services/api/finance/bank-account-transaction.service";
import { BankAccountsServices } from "../../_services/api/finance/bankAccounts";

function mapPaymentLine(line) {
  return {
    GLChartCode: line.AccountCode.toString(),
    GLChartDescription: line.GLDescription,
    BranchCode: line.BranchCode,
    DivisionCode: line.DivisionCode,
    Comment: line.Comment,
    Amount: line.Amount,
    FxAmount: line.FXAmount,
  };
}

function mapReceiptLine(line) {
  return {
    GLChartCode: line.AccountCode.toString(),
    GLChartDescription: line.GLDescription,
    Comment: line.Comment,
    Amount: line.Amount,
    FxAmount: line.FXAmount,
  };
}

/**
 * Fetches a Sundry Payment/Receipt's full header + lines from a CashBook row
 * (Transaction / Sundry Transaction list) and shapes it into the same
 * `copySource` structure sundry-payment.vue/sundry-receipt.vue build for their
 * own review-screen Copy action, so GcSundryTransactionPopup's applyCopySource()
 * can pre-populate from it unchanged.
 */
export async function buildSundryTransactionCopySource(row) {
  const isPayment = row.TransactionType === "Sundry Payment";
  const endpoint = isPayment ? "SundryPayment" : "SundryReceipt";

  const { data: headerData } = await TransactionService.getByCode(
    endpoint,
    `Code eq ${row.Transaction}`,
  );
  const record = headerData.value[0];

  const { data: linesData } = isPayment
    ? await BankAccountTransactionServices.getSundryPaymentDetailsByCode(
      row.Transaction,
    )
    : await BankAccountTransactionServices.getSundryReceiptDetailsByCode(
      row.Transaction,
    );
  const lines = linesData.value.map(isPayment ? mapPaymentLine : mapReceiptLine);

  const header = isPayment
    ? {
      SupplierCode: record.SupplierCode,
      PayeeName: record.PayeeName,
      IsGstReportable: record.IsGstReportable,
      GSTAmount: record.GSTAmount,
      FXTaxAmount: record.FXTaxAmount,
      CurrencyCode: record.CurrencyCode,
      ExchangeRate: record.ExchangeRate,
      Reference: record.Reference,
      Narration: record.Narration,
    }
    : {
      CustomerCode: record.CustomerCode,
      PayeeName: record.PayeeName,
      PaymentMethod: record.PaymentMethod,
      BranchCode: record.BranchCode,
      DivisionCode: record.DivisionCode,
      IsGstReportable: record.IsGstReportable,
      TaxAmount: record.TaxAmount,
      FXTaxAmount: record.FXTaxAmount,
      CurrencyCode: record.CurrencyCode,
      ExchangeRate: record.ExchangeRate,
      Reference: record.Reference,
      Narration: record.Narration,
    };

  let bankAccount = {};
  await BankAccountsServices.getBankRecordByCode(record.BankAccountCode).then(
    ({ data }) => {
      if (data.value.length > 0) bankAccount = data.value[0];
    },
  );

  return {
    screenType: isPayment ? "new-sundry-payment" : "new-sundry-receipt",
    header,
    lines,
    bankAccountCode: record.BankAccountCode,
    bankAccountName: bankAccount.AccountName,
    bsbNo: bankAccount.BsbNo,
    accountNo: bankAccount.AccountNo,
  };
}
